import {
    FruitfulCustomIcon,
    SPACE_COLORS,
    View,
    XStack,
    YStack,
} from 'smoothie';

interface ColorSelectionProps {
    icon: string;
    selectedColor: string;
    onSelect: (color: string) => void;
}

const ColorSelection = ({
    icon,
    selectedColor,
    onSelect,
}: ColorSelectionProps) => {
    const colors = Object.keys(SPACE_COLORS).filter(
        (color) => color !== 'greenleaf',
    ); // TODO: Clean up later after handling legacy color scheme

    const rows: string[][] = [];
    for (let i = 0; i < colors.length; i += 3) {
        rows.push(colors.slice(i, i + 3));
    }

    return (
        <YStack alignItems="center" height={240}>
            {rows.map((row, index) => (
                <XStack key={index} justifyContent="center">
                    {row.map((color) => (
                        <ColorSelect
                            key={color}
                            icon={icon}
                            color={color}
                            isSelected={selectedColor === color}
                            onPress={() => {
                                onSelect(color);
                            }}
                        />
                    ))}
                </XStack>
            ))}
        </YStack>
    );
};

interface ColorProps {
    color: string;
    icon: string;
    isSelected: boolean;
    onPress: () => void;
}

const ColorSelect = ({ color, icon, isSelected, onPress }: ColorProps) => {
    return (
        <View
            padding={6}
            borderRadius={32}
            borderWidth={2}
            borderColor={isSelected ? '$black' : 'transparent'}
            justifyContent="center"
            onPress={onPress}
            cursor="pointer"
        >
            <FruitfulCustomIcon icon={icon} color={color} size="xl" />
        </View>
    );
};

export default ColorSelection;
